const partnersData = [
    {
        id:"1",
        image:require("../../assets/partners/partners-1.webp")
    },
    {
        id:"2",
        image:require("../../assets/partners/2.webp")
    },
    {
        id:"3",
        image:require("../../assets/partners/3.webp")
    },
    {
        id:"4",
        image:require("../../assets/partners/4.webp")
    },
    {
        id:"5",
        image:require("../../assets/partners/5.webp")
    },
    {
        id:"6",
        image:require("../../assets/partners/6.webp")
    },
    {
        id:"7",
        image:require("../../assets/partners/7.webp")
    },
    {
        id:"88",
        image:require("../../assets/partners/8.webp")
    },
    {
        id:"9",
        image:require("../../assets/partners/9.webp")
    },
    {
        id:"10",
        image:require("../../assets/partners/10.webp")
    },
]

export default partnersData;